__turbopack_context__.v({
  "className": "caveat_ede53ef5-module__KO7OJG__className",
});
